<template>

    <div id="layout-blank">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>

</template>

<style scoped lang="scss">

    #layout-blank {
        padding: 0 10px;
    }

</style>

<script>

export default {

    mounted() {
        window.Beacon('destroy');
        window.Beacon('on', 'ready', () => window.Beacon('destroy'));
    },

}

</script>
